// Webpack CSS import
import Vue from 'vue'
import App from './App.vue'
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './theme/main.css';
import {initAuthInterceptor, initFireBaseUI} from "./config";
import globalConfig from "./util/globalConfig";
import router from './router/path'
import VueOnsen from 'vue-onsenui'; // This imports 'onsenui', so no need to import it separately
var SocialSharing = require('vue-social-sharing');

Vue.use(SocialSharing);
Vue.use(VueOnsen); // VueOnsen set here as plugin to VUE. Done automatically if a call to window.Vue exists in the startup code.

Vue.config.productionTip = false;
initAuthInterceptor(globalConfig.appId, globalConfig.web_apiKey);

// Miniapp.initialize().then(function (initalizationResponse) {
//     initAuthInterceptor(globalConfig.appId, globalConfig.web_apiKey);
// }).catch(function (err) { 
//     console.log("error while initializing miniapp: ", err);
// });
// checkAccessTokenPeriod();



new Vue({
    el: '#app',
    created() {
        // initFireBaseUI()
    },
    router,
    render: h => h(App),
});
